module.exports = __webpack_public_path__ + "static_wap_online/img/home-LOGO-app@2x.77b66ed4.png";